"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionsByOrderedItemTooltipContent = exports.ResponseOptionsTooltipContent = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var ResponseOptionsTooltipContent = function (headingDisplayText, responseOptions, descriptionDisplayText) { return (React.createElement("div", null,
    React.createElement("strong", null, headingDisplayText),
    descriptionDisplayText !== undefined && React.createElement("p", null, descriptionDisplayText),
    React.createElement("ul", null, responseOptions !== undefined &&
        responseOptions.map(function (ro, index) { return (React.createElement("li", { key: index, className: 'response-option' }, ro)); })))); };
exports.ResponseOptionsTooltipContent = ResponseOptionsTooltipContent;
// NOTE: this is a simple override for situations where we ONLY need tooltip content
var ResponseOptionsByOrderedItemTooltipContent = function (displayText, responseOptions) {
    var orderedResponseOptions = lodash_1.default.orderBy(responseOptions, ['displayOrder'], ['asc']);
    var responseOptionDisplayNames = lodash_1.default.map(orderedResponseOptions, function (o) { return o.displayText; });
    return (0, exports.ResponseOptionsTooltipContent)(displayText, responseOptionDisplayNames);
};
exports.ResponseOptionsByOrderedItemTooltipContent = ResponseOptionsByOrderedItemTooltipContent;
